import {EventType} from "./index";
import {formattingDate} from "../utils/common";
import {NO_TIME_LIMIT_TEXT, priorityColorClass} from "../utils/consts";

const getFormattedDate = (date) => {
  const noTimeUpperCase = NO_TIME_LIMIT_TEXT[0].toUpperCase() + NO_TIME_LIMIT_TEXT.slice(1);

  return date && date.toLowerCase() !== NO_TIME_LIMIT_TEXT ?
    formattingDate(new Date(date), {showWeekDay: true}) :
    noTimeUpperCase;
};

const getCurrentUserTemplate = ({name, img}) => `<div class="comments__user">
    <img class="comments__user-img" src="${img}" width="22" height="22"
         alt="${name}">
    <h3 class="comments__user-name heading">
        ${name}
        <span class="comments__user-date">${formattingDate(new Date(), {
  showTime: true,
  separator: ` в `,
})}</span>
    </h3>
</div>`;

const getUserTemplate = ({name, img}) => `<div class="comments__user">
    <img class="comments__user-img" src="${img}" width="22" height="22"
         alt="${name}">
    <p class="comments__user-name">${name}</p>
</div>`;

const getAuthorTemplate = ({user, currentAuthor, newAuthor}) => {
  return `<li class="comments__event event event--change-responsible">
      ${getCurrentUserTemplate(user)}
      <span class="event__action">Изменил автора</span>
      <div class="event__details">
          ${getUserTemplate(currentAuthor)}
          <span class="event__arrow">→</span>
          ${getUserTemplate(newAuthor)}
      </div>
  </li>`;
};

const getCallUserTemplate = ({user, newUser}) => {
  return `<li class="comments__event event event--call-creator">
        ${getCurrentUserTemplate(user)}
        <span class="event__action">Позвал</span>
        <span class="event__arrow">→</span>
        ${getUserTemplate(newUser)}
    </li>`;
};

const getDeadlineTemplate = ({user, date}) => {
  return `<li class="comments__event event event--change-date">
      ${getCurrentUserTemplate(user)}
      <span class="event__action">Изменил срок</span>
      <div class="event__details">
          <span class="event__text">${getFormattedDate(date.old)}</span>
          <span class="event__arrow">→</span>
          <span class="event__text">${getFormattedDate(date.new)}</span>
      </div>
  </li>`;
};

const getPriorityTemplate = ({user, priority}) => {
  return `<li class="comments__event event event--change-priority">
      ${getCurrentUserTemplate(user)}
      <span class="event__action">Изменил приоритет</span>
      <div class="event__details priority">
          <div class="priority__block ${priorityColorClass[priority.old]}">
              <span class="priority__text">${priority.old}</span>
          </div>
          <span class="event__arrow">→</span>
          <div class="priority__block ${priorityColorClass[priority.new]}">
              <span class="priority__text">${priority.new}</span>
          </div>
      </div>
  </li>`;
};

const getResponsibleTemplate = ({user, oldResponsible, newResponsible}) => {
  return `<li class="comments__event event event--change-responsible">
        ${getCurrentUserTemplate(user)}
        <span class="event__action">Изменил ответственного</span>
        <div class="event__details">
            ${getUserTemplate(oldResponsible)}
            <span class="event__arrow">→</span>
            ${getUserTemplate(newResponsible)}
        </div>
    </li>`;
};

const getCloseTemplate = ({user}) => {
  return `<li class="comments__event event event--close-task">
        ${getCurrentUserTemplate(user)}
        <span class="event__action">Закрыл задачу</span>
    </li>`;
};


const getOpenTemplate = ({user}) => {
  return `<li class="comments__event event event--open-task">
        ${getCurrentUserTemplate(user)}
        <span class="event__action">Открыл задачу</span>
    </li>`;
};

export const getTemplate = (type, options) => {
  switch (type) {
    case EventType.AUTHOR:
      return getAuthorTemplate(options);
    case EventType.CALL_USER:
      return getCallUserTemplate(options);
    case EventType.DEADLINE:
      return getDeadlineTemplate(options);
    case EventType.PRIORITY:
      return getPriorityTemplate(options);
    case EventType.RESPONSIBLE:
      return getResponsibleTemplate(options);
    case EventType.CLOSE:
      return getCloseTemplate(options);
    case EventType.OPEN:
      return getOpenTemplate(options);
  }
};
